<template>
  <vg-field
      v-bind="$attrs"
      v-on="$listeners"
      :label="label"
      :value="value"
      type="textarea"
      rows="1"
      autosize
      :placeholder="`请选择${label}`"
      readonly
      is-link
      @click="pick"
  />

</template>

<script>
import {Toast} from "vant";
import {mapState} from "pinia";
import useConstructionLocationPickerStore from "@/store/construction-location-picker-store";
import useProfitCenterPickerStore from "@/store/profit-center-picker-store";
import VgField from "@/components/Commons/VgField.vue";

export default {
  name: "DpApplicationConstructionLocationField",
  components: {VgField},
  props: {
    label: String,
    value: null,
    disabled: Boolean,
  },
  mounted() {
    if (this.picked) {
      this.input(this.picked)
    }
  },
  watch: {
    value(newValue) {
      useConstructionLocationPickerStore().pick(newValue)
    },
    picked(newValue) {
      this.input(newValue)
    }
  },
  computed: {
    ...mapState(useConstructionLocationPickerStore, {picked: 'picked'}),
    ...mapState(useProfitCenterPickerStore, {pickedProfitCenter: 'picked'})
  },
  methods: {
    input(value) {
      this.$emit('input', value)
    },
    pick() {
      const cheetahId = this.pickedProfitCenter?.cheetahId
      if (!cheetahId) {
        Toast.fail('请选择项目')
        return
      }
      this.$router.push({
        name: 'leo-project-construction-locations-picker',
        params: {
          cheetahId
        }
      })
    },
    validate() {

    }
  }
}
</script>

<style scoped>

</style>